import { render, staticRenderFns } from "./EstadoInscripcionDialog.vue?vue&type=template&id=779cdb0d&scoped=true&"
import script from "./EstadoInscripcionDialog.vue?vue&type=script&lang=js&"
export * from "./EstadoInscripcionDialog.vue?vue&type=script&lang=js&"
import style0 from "./EstadoInscripcionDialog.vue?vue&type=style&index=0&id=779cdb0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779cdb0d",
  null
  
)

export default component.exports